import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../store-context";
import { IView, IWindowSize, LeftSliderType, ShareDialog } from "../types";

export const useCommentsScrollSelector = (): boolean =>
  useContextSelector(StoreContext, (store: IStore) => store.view.commentsScroll);

export const useScrollAnswerSelector = (): "on" | "off" =>
  useContextSelector(StoreContext, (store: IStore) => store.view.notificationScroll.scrollToAnswer);

export const useShareDialogSelector = (): ShareDialog | null =>
  useContextSelector(StoreContext, (store: IStore) => store.view.shareDialog);

export const useWindowSizeSelector = (): IWindowSize =>
  useContextSelector(StoreContext, (store: IStore) => store.view.windowSize);

export const useLeftSliderSelector = (): LeftSliderType =>
  useContextSelector(StoreContext, (store: IStore) => store.view.leftSlider);

export const useScrollToQuestionSelector = (): boolean =>
  useContextSelector(StoreContext, (store: IStore) => store.view.scrollToQuestion);

export const useEmailBoxUpdateSelector = (): boolean =>
  useContextSelector(StoreContext, (store: IStore) => store.view.emailBoxUpdate);

export const useSelectError409 = (): string => useContextSelector(StoreContext, (store: IStore) => store.view.error409);

export const useReportDealViewSelector = (): { id: number; title: string } =>
  useContextSelector(StoreContext, (store: IStore) => store.view.reportDealView);

export const useDealRedirectSelector = (): IView["dealRedirect"] =>
  useContextSelector(StoreContext, (store: IStore) => store.view.dealRedirect);

export const useCrunchbaseDrawerSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.view.cruchbaseDrawerState);

export const useCryptoCurrencyDrawerSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.view.cryptoCurrencyDrawerState);

export const useCreateManyMeasureDataSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.view.createManyMeasureData);

export const useSelectedQuestionSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.view.selectedQuestion);

export const useQuickViewAddNewLineSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.view.quickViewAddNewLine);

export const useIsDealCharBarOpenSelect = (): boolean =>
  useContextSelector(StoreContext, (store: IStore) => store.view.isDealCharBarOpen);

export const useSidebarStateSelect = (): boolean =>
  useContextSelector(StoreContext, (store: IStore) => store.view.sidebarState);
